import hiLocale from 'element-ui/lib/locale/lang/zh-CN' //引入element语言包 印地语
const hi = {
  Login: {
    ToLogin: 'लगइन',
    PhoneLogin: 'फोन संख्या के साथ लॉगिन करें',
    EmailLogin: 'इमेल लागइन',
    PhonePlaceholder: 'कृपया अपना फोन संख्या भरें',
    EmailPlaceholder: 'Enter email',
    Code: 'परीक्षण कोड',
    and: 'और',
    BeforeText: 'एक खाता निर्माण करने के लिए तुम्हारी सहमता और अनुसरण का प्रतिनिधित्व करता है',
    UserAgreement: 'प्रयोक्ता स्वीकार',
    privacy: 'निजी नीति',
    errorMessage: 'सत्यापन कोड त्रुटि',
    readTitle: 'निम्न सहमता के साथ पढ़ने और स्वीकार करें',
    readBefore: 'अपने व्यक्तिगत जानकारी की सुरक्षा सुनिश्चित करने के लिए, कृपया पहले पढ़ने और संमति से मिलें',
    cancel: 'रद्द करें',
    agree: 'स्वीकार करें और जारी रखें',
    error1:'कृपया एक वैध ईमेल पता दर्ज करें',
    error2:'कृपया सही फोन नंबर दर्ज करें',
    error3:'कृपया कोड दर्ज करें',
    success:'सफलतापूर्वक प्रवेश'
  },
  ...hiLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default hi;
